import { render, staticRenderFns } from "./antiepidemic.vue?vue&type=template&id=a117c704&scoped=true&"
import script from "./antiepidemic.vue?vue&type=script&lang=js&"
export * from "./antiepidemic.vue?vue&type=script&lang=js&"
import style0 from "./antiepidemic.vue?vue&type=style&index=0&id=a117c704&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a117c704",
  null
  
)

export default component.exports